/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractExtensionChannel, UserChannelInfo } from './AbstractExtensionChannel'

export class LineExtensionChannel extends AbstractExtensionChannel {
  public checkIsClient(): boolean {
    return window.liff.isInClient() ? window.liff.isInClient() : false
  }

  public checkLogin(): boolean {
    return window.liff.isLoggedIn() ? window.liff.isLoggedIn() : false
  }

  public Login(): void {
    window.liff.login()
  }

  public Logout(): void {
    window.liff.logout()
  }

  closeWindow(): void {
    window.liff.closeWindow()
    if (this.checkIsClient()) {
      window.liff.closeWindow()
    } else {
      window.close()
    }
  }

  async getUserProfile(): Promise<UserChannelInfo> {
    return window.liff
      .getProfile()
      .then((profile: any) => {
        return {
          userId: profile.userId,
          displayName: profile.displayName,
          pictureUrl: profile.pictureUrl
        } as UserChannelInfo
      })
      .catch((err: any) => {
        throw new Error(err)
      })
  }

  init(): void {}
}
